import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import dayjs from 'dayjs';
import fromNow from '@/utils/filters/fromNow';
import capitalizeFirst from '@/utils/filters/capitalizeFirst';
import i18n from '@/i18n';
import type {
  AssetDto,
  TransformationAssetDto,
} from '@/api';
import ConnectorSourceDestination from '@/components/asset/overview/Connector-Source-Destination.vue';
import ConnectorStatus from '@/components/asset/overview/Connector-Status.vue';

interface AssetOverviewTransformationProps {
  transformation: TransformationAssetDto,
  readonly urn: AssetDto['urn'],
  isSmall?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Asset-Overview-Transformation',
  props: {
  transformation: null,
  urn: null,
  isSmall: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props;



const lastSuccessfulRunDate = computed(() => fromNow(props.transformation.lastSuccessfulRunDate));
const createdDate = computed(() => fromNow(props.transformation.createdDate));
const runFrequency = computed(() => {
  const frequencyDuration = props.transformation.runFrequencySeconds ? dayjs.duration(props.transformation.runFrequencySeconds * 1000) : dayjs.duration(0);
  const hours = frequencyDuration.asHours();
  return i18n.tc('assets.transformation.every_hour', hours) as string;
});

const capitalize = (string: string) => capitalizeFirst(string);
const spacingClasses = computed(() => (props.isSmall ? '' : 'my-4 py-4 px-4'));

return { __sfc: true,props, lastSuccessfulRunDate, createdDate, runFrequency, capitalize, spacingClasses, computed, dayjs, fromNow, capitalizeFirst, i18n, ConnectorSourceDestination, ConnectorStatus }
}

})